/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ProductDeleteToastNotification.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422336
 *
 * @Date		: Oct 12 2020
 *
 * @Version      : Version 1.0
 *
*******************************************************************************/
import * as  React from 'react';
import { Notification } from '@scuf/common';

interface IUpdateToast {
    closeToast: any;
    success: boolean;
}

function handleSupportLink() {
    window.open('mailto:dsa@honeywellaerospace.com', '_blank', 'noopener');
}

function ProductDeleteToastNotification(props: IUpdateToast) {
    return (
        <React.Fragment>
            {props.success ?
                <Notification
                    className="toast-notification"
                    hasIcon={true}
                    title={`Product was successfully deleted!`}
                    severity="success"
                /> :
                <Notification
                    className="toast-notification delete"
                    hasIcon={true}
                    title={`Failure while deleting the Product`}
                    severity="critical"
                    detailsText="Contact Support Team"
                    onDetailsClick={handleSupportLink}
                >
                    <p>We are unable to delete the following product.</p>
                    <p>Please try again after sometime or contact Honeywell Support Team </p>
                </Notification>
            }
            </React.Fragment>
    );
}

export default ProductDeleteToastNotification;
